import { Component, OnInit } from '@angular/core';
import { FormUtils } from 'app/tools/form-utils';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-nr-protocolo',
  templateUrl: './text-nr-protocolo.component.html',
  styleUrls: ['./text-nr-protocolo.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextNrProtocoloComponent implements OnInit {

  public mask = FormUtils.NR_PROTOCOLO;
  constructor() { }

  ngOnInit() {
  }

}
